document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector(".custom-header-container");
  var stickyOffset = header.offsetTop;
  var headerHeight = header.offsetHeight;

  // Create a placeholder element
  var placeholder = document.createElement("div");
  placeholder.style.height = headerHeight + "px";
  placeholder.style.display = "none";
  header.parentNode.insertBefore(placeholder, header);

  window.addEventListener("scroll", function () {
    if (window.scrollY > stickyOffset) {
      header.classList.add("sticky");
      placeholder.style.display = "block";
    } else {
      header.classList.remove("sticky");
      placeholder.style.display = "none";
    }
  });

  // Add has-dropdown class to menu items with dropdowns
  document.querySelectorAll(".mega-menu .main-menu-item").forEach((item) => {
    if (item.querySelector(".dropdown")) {
      item.classList.add("has-dropdown");
    }
  });

  // Add active class to current page links
  const currentUrl = window.location.pathname;
  document.querySelectorAll(".custom-header a").forEach((link) => {
    const href = link.getAttribute("href");
    if (href && href === currentUrl) {
      link.classList.add("active");
    }
  });

  // Drag scroll functionality
  const menuContainer = document.querySelector(".mega-menu");
  document.querySelectorAll(".mega-menu a").forEach((link) => {
    link.setAttribute("draggable", "false");
  });

  let isDown = false;
  let startX;
  let scrollLeft;

  menuContainer.addEventListener("mousedown", (e) => {
    isDown = true;
    menuContainer.classList.add("active");
    startX = e.pageX - menuContainer.offsetLeft;
    scrollLeft = menuContainer.scrollLeft;
    e.preventDefault(); // Prevents accidental drag of link or text
  });

  menuContainer.addEventListener("mouseleave", () => {
    isDown = false;
    menuContainer.classList.remove("active");
  });

  menuContainer.addEventListener("mouseup", () => {
    isDown = false;
    menuContainer.classList.remove("active");
  });

  menuContainer.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault(); // Prevents accidental link interference
    const x = e.pageX - menuContainer.offsetLeft;
    const walk = (x - startX) * 2; // The higher the multiplier, the faster the scroll
    menuContainer.scrollLeft = scrollLeft - walk;
  });

  menuContainer.addEventListener("touchstart", (e) => {
    startX = e.touches[0].pageX - menuContainer.offsetLeft;
    scrollLeft = menuContainer.scrollLeft;
  });

  menuContainer.addEventListener("touchmove", (e) => {
    const x = e.touches[0].pageX - menuContainer.offsetLeft;
    const walk = (x - startX) * 2;
    menuContainer.scrollLeft = scrollLeft - walk;
    e.preventDefault(); // Prevents page scrolling
  });

  document
    .getElementById("mobile-menu_icon--menu")
    .addEventListener("click", function () {
      const megaMenu = document.querySelector(".mega-menu-mobile");
      const header = document.querySelector(".custom-header");
      megaMenu.classList.toggle("active");
      header.classList.toggle("active");
    });

  document
    .getElementById("mobile-menu_icon--close")
    .addEventListener("click", function () {
      const megaMenu = document.querySelector(".mega-menu-mobile");
      const header = document.querySelector(".custom-header");
      megaMenu.classList.toggle("active");
      header.classList.toggle("active");
    });

  document.querySelectorAll(".main-menu-item").forEach((item) => {
    item.addEventListener("click", function (event) {
      // Check if the click event originated from inside the nested-card
      if (event.target.closest(".nested-card")) {
        return; // Do nothing if the click is from inside the nested-card
      }
      const nestedCard = this.querySelector(".nested-card");
      if (nestedCard) {
        nestedCard.classList.toggle("active");
      }
    });
  });

  document
    .querySelectorAll(".mobile-card_icon--chevron-left")
    .forEach((button) => {
      button.addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent the click event from bubbling up to the parent .main-menu-item
        const nestedCard = this.closest(".nested-card");
        if (nestedCard) {
          nestedCard.classList.remove("active");
        }
      });
    });

  document.querySelectorAll(".nested-card_icon--close").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent the click event from bubbling up to the parent .main-menu-item
      const nestedCard = this.closest(".nested-card");
      const megaMenu = document.querySelector(".mega-menu-mobile");
      const header = document.querySelector(".custom-header");
      if (nestedCard) {
        nestedCard.classList.remove("active");
      }
      megaMenu.classList.remove("active");
      header.classList.remove("active");
    });
  });

  document.querySelectorAll('.mega-menu.desktop-only .main-menu-item > h4').forEach(div => {
    div.style.width = 'fit-content';
    const fitWidth = div.offsetWidth;
    div.style.width = (fitWidth + 8) + 'px';
  });

  document.querySelectorAll('.mega-menu.desktop-only .main-menu-item > a > h4').forEach(div => {
    div.style.width = 'fit-content';
    const fitWidth = div.offsetWidth;
    div.style.width = (fitWidth + 8) + 'px';
  });

  function setH4Widths() {
    document.querySelectorAll('.mega-menu.desktop-only .sub-sub-menu-item > a > h4').forEach(div => {
      // Only set width if it hasn't been set already
      if (!div.dataset.widthSet) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            div.style.width = 'auto';
            const fitWidth = div.offsetWidth;
            if (fitWidth > 0) {
              div.style.width = (fitWidth) + 'px';
              div.dataset.widthSet = 'true';
            }
          });
        });
      }
    });
  }

  // Trigger when mega-menu is hovered
  document.querySelector('.mega-menu').addEventListener('mouseenter', setH4Widths);

  // Also trigger on page load to ensure widths are set
  window.addEventListener('load', () => {
    setTimeout(setH4Widths, 200);
  });
});
